import React from "react";
import {
	Card,
	CardContent,
	Typography,
	Grid2,
	Checkbox,
	FormControlLabel,
} from "@mui/material";
import Divider from "@mui/material/Divider";

const FilterPanel = ({
	filterStatus,
	onFilterChange,
	filterCompany,
	onCompanyFilterChange,
}) => (
	<>
		<Card>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					<strong>Filter by Status</strong>
				</Typography>
				<Divider sx={{ mb: 2 }} />
				<Grid2 container direction="column">
					{Object.keys(filterStatus).map((status) => (
						<FormControlLabel
							key={status}
							control={
								<Checkbox
									checked={filterStatus[status]}
									onChange={onFilterChange}
									name={status}
								/>
							}
							label={status}
							sx={{
								"& .MuiTypography-root": {
									fontSize: "0.875rem",
								},
							}}
						/>
					))}
				</Grid2>
			</CardContent>
		</Card>

		<Card sx={{ mt: 2 }}>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					<strong>Filter by Insurance Company</strong>
				</Typography>
				<Divider sx={{ mb: 2 }} />
				<Grid2 container direction="column">
					{[
						"Select All",
						...Object.keys(filterCompany)
							.filter((k) => k !== "Select All")
							.sort(),
					].map((name) => (
						<FormControlLabel
							key={name}
							control={
								<Checkbox
									checked={!!filterCompany[name]}
									onChange={onCompanyFilterChange}
									name={name}
								/>
							}
							label={name}
							sx={{
								"& .MuiTypography-root": {
									fontSize: "0.875rem",
									textAlign: "left",
								},
							}}
						/>
					))}
				</Grid2>
			</CardContent>
		</Card>
	</>
);

export default FilterPanel;
